import { useAtomValue } from 'jotai';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { filterSetsAtom } from '@/atoms/queries/userConfigs';
import { TEMPORARY_FILTER_SET_ID } from '@/consts/filters/filterSets';
import { filterSetQueryParams, getTempFilterSet } from '@/utils/filters';
import { useUpdateQueryString } from './useUpdateQueryString';

export const useNavigateToFilterSetId = (path?: string, onAfterHandler?: () => void) => {
  const filterSets = useAtomValue(filterSetsAtom);
  const [searchParams] = useSearchParams();
  const updateQueryString = useUpdateQueryString(searchParams);
  const navigate = useNavigate();

  return async (filterIdToNavigateTo: string | null) => {
    /* this handles the logic for if selectedFilterIdToLoad is null
        so that we don't need to appease TS with the ! operator
        but we can't actually test this part of the onConfirm since
        the button is disabled if it's null 
    */
    if (!filterIdToNavigateTo) return;

    const useTempFilterSet = filterIdToNavigateTo === TEMPORARY_FILTER_SET_ID;

    /* if the filterSetToNavigateTo isn't the temp one */
    const selectedFilterSetToLoad = useTempFilterSet
      ? await getTempFilterSet()
      : filterSets.find(({ configId }) => configId === filterIdToNavigateTo);

    const keysToAdd = filterSetQueryParams(filterIdToNavigateTo, selectedFilterSetToLoad?.definition.filters.metric);

    const newQueryString = updateQueryString(keysToAdd);
    navigate(`${path || ''}?${newQueryString}`);

    if (onAfterHandler) onAfterHandler();
  };
};
